module.exports = __webpack_public_path__ + "static/logo24.6b30174d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo24.jpg
// module id = 794
// module chunks = 79611799117203 84521481881339